<template>
  <div class="gm-panel layer-selector gm-scroll">
    <h3 class="gm-title layer-selector-title">Dimensional Layers</h3>
    <div class="layers-list">
      <div
        v-for="layer in layers"
        :key="layer.id"
        :class="['layer-item', {
          'active': layer.id === currentLayer,
          'inactive-dimension': !layer.active
        }]"
        @click="selectLayer(layer.id)"
      >
        <div class="layer-header">
          <span class="layer-number">{{ layer.id }}</span>
          <span class="layer-name">{{ layer.name }}</span>
        </div>
        <div class="layer-info">
          <span class="layer-description">{{ layer.description }}</span>
          <span class="layer-energy">Energy: {{ layer.energyCost }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LayerSelector',
  computed: {
    ...mapGetters('tabletopEditor', [
      'currentMap',
      'currentLayer'
    ]),
    layers() {
      return this.currentMap?.layers || [];
    }
  },
  methods: {
    ...mapActions('tabletopEditor', [
      'setCurrentLayer'
    ]),
    selectLayer(layerId) {
      this.setCurrentLayer(layerId);
    }
  }
};
</script>

<style scoped>
.layer-selector {
  max-height: 37.5rem;
}

.layer-selector-title {
  margin: 0 0 var(--gm-gap);
}

.layers-list {
  display: flex;
  flex-direction: column;
  gap: var(--gm-gap-sm);
}

.layer-item {
  background: var(--gm-surface-2);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius);
  padding: var(--gm-gap-sm);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.layer-item:hover {
  background: var(--gm-accent-soft);
  border-color: var(--gm-border);
}

.layer-item.active {
  background: rgba(255, 215, 0, 0.12);
  border-color: var(--gm-border-hi);
}

.layer-item.inactive-dimension {
  opacity: 0.5;
}

.layer-item.inactive-dimension .layer-name::after {
  content: ' (Locked)';
  font-size: 0.7rem;
  color: var(--gm-danger);
}

.layer-header {
  display: flex;
  align-items: center;
  gap: var(--gm-gap-sm);
  margin-bottom: 0.3rem;
}

.layer-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  background: var(--gm-accent-soft);
  border: 1px solid var(--gm-border);
  border-radius: 50%;
  font-weight: bold;
  font-size: 0.85rem;
  color: var(--gm-accent);
}

.layer-item.active .layer-number {
  background: var(--gm-accent);
  color: #16130c;
}

.layer-name {
  font-weight: bold;
  font-size: 0.85rem;
  color: var(--gm-text);
}

.layer-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.7rem;
  color: var(--gm-text-muted);
  padding-left: 2.4rem;
}

.layer-description {
  font-style: italic;
}

.layer-energy {
  color: var(--gm-info);
  font-weight: 500;
}
</style>
